import React, { useEffect, useState } from "react";
import { Grid, Button, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { copyToClipboard } from "@Utils/copyToClipboard";

type SharedLinkProps = {
    openDialog: boolean;
    link: string;
    channel_title: string;
};

const SharedLinkContent: React.FC<SharedLinkProps> = ({
    openDialog,
    link,
    channel_title,
}: SharedLinkProps) => {
    const { t } = useTranslation();
    const [isLoading, setisLoading] = useState(true);

    useEffect(() => {
        if (openDialog) {
            setisLoading(true);
            setTimeout(() => {
                setisLoading(false);
            }, 300);
        }
    }, [openDialog]);

    return (
        <>
            {t("dialogs.copy.title")}
            <Grid
                container
                direction="row-reverse"
                justifyContent="space-around"
                alignItems="center"
                sx={{ mt: "30px" }}
            >
                {isLoading ? (
                    <CircularProgress color="primary" />
                ) : (
                    <React.Fragment>
                        <Grid item xs={12}>
                            <TextField
                                label={`Share link of: ${channel_title}`}
                                id="outlined-name-input"
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                                value={link}
                            />
                        </Grid>
                    </React.Fragment>
                )}
            </Grid>
        </>
    );
};

const SharedLinkActions: React.FC<SharedLinkProps> = ({
    link,
}: SharedLinkProps) => {
    const { t } = useTranslation();

    const handleCopy = () => copyToClipboard(link);

    return (
        <>
            <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={handleCopy}
            >
                {t("dialogs.copy.link")}
            </Button>
        </>
    );
};

export default {
    content: React.memo(SharedLinkContent),
    actions: SharedLinkActions,
    title: "Share Link",
};
